import React from "react";
import { Typography } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { useSpring, animated } from "@react-spring/web";

const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

const getWhiteEvalPercent = (evaluation) => {
  if (!evaluation) return 50;
  if (evaluation.type === "mate") return evaluation.value > 0 ? 100 : 0;
  return clamp(50 + evaluation.value / 20, 0, 100);
};

const EvaluationBar = ({ evaluation, playerColor, boardWidth = 500, fontColor="black" }) => {
  const isPlayerWhite = playerColor === "white";

  const perspectiveValue =
    evaluation?.type === "cp"
      ? (isPlayerWhite ? evaluation.value : -evaluation.value)
      : evaluation?.value;

  const whitePercent = getWhiteEvalPercent({
    ...evaluation,
    value: perspectiveValue,
  });

  const blackPercent = 100 - whitePercent;
  const userPercent = isPlayerWhite ? whitePercent : blackPercent;
  const opponentPercent = 100 - userPercent;

  const animatedNumber = useSpring({
    from: { val: 0 },
    val: evaluation?.type === "cp" ? perspectiveValue / 100 : perspectiveValue,
    config: { tension: 170, friction: 26 },
  });

  const renderIcon = () =>
    (isPlayerWhite && perspectiveValue >= 0) || (!isPlayerWhite && perspectiveValue <= 0) ? (
      <ThumbUpAltIcon fontSize="small" style={{ color: "green", verticalAlign: "middle" }} />
    ) : (
      <ThumbDownAltIcon fontSize="small" style={{ color: "red", verticalAlign: "middle" }} />
    );

  return (
    <div style={{ marginTop: 10, width: boardWidth, textAlign: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "20px",
          width: "100%",
          border: "1px solid #999",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor: isPlayerWhite ? "white" : "black",
            width: `${userPercent}%`,
            height: "100%",
          }}
        />
        <div
          style={{
            backgroundColor: isPlayerWhite ? "black" : "white",
            width: `${opponentPercent}%`,
            height: "100%",
          }}
        />
      </div>

      <Typography variant="caption" style={{ marginTop: 4, display: "flex", justifyContent: "center", gap: "6px", color: fontColor }}>
        {evaluation?.type === "cp" ? (
          <>
            <animated.span>
              {animatedNumber.val.to((n) => `${n >= 0 ? "+" : ""}${n.toFixed(2)}`)}
            </animated.span>
            {renderIcon()}
          </>
        ) : (
          `#${Math.abs(evaluation?.value)}`
        )}
      </Typography>
    </div>
  );
};

export default EvaluationBar;
